import { render, staticRenderFns } from "./PersonEntryForm.vue?vue&type=template&id=52c96492&scoped=true"
import script from "./PersonEntryForm.vue?vue&type=script&lang=js"
export * from "./PersonEntryForm.vue?vue&type=script&lang=js"
import style0 from "./PersonEntryForm.vue?vue&type=style&index=0&id=52c96492&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c96492",
  null
  
)

export default component.exports